import { get as getDict } from '@/api/dictDetail'

export async function get(type) {
  let values = []
  await getDict(type).then((res) => {
    values = res.data.records
  })
  return values
}
